import { toastError } from '@/services/toast';
import { Modalities } from '@/types/modalities';

import { apiClient } from '..';
import useModalitiesStore from '@/store/modalitiesStore';
import { getGurupassClient } from '@/services/gurupass-api-client';
import { CreateModalityRequest, Modality } from '@gurupass/sdk';

const modalitiesStore = useModalitiesStore.getState();

export async function getModalities(
	forceRequest = false
): Promise<Modalities[] | undefined> {
	if (!forceRequest && modalitiesStore.modalities.length > 0) {
		return modalitiesStore.modalities;
	}

	const client = getGurupassClient();
	try {
		const response = await client?.admin.modalities().list().run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}
type createModalitytype = {
	name: string;
	description: string | undefined;
};

export async function createModalityService(
	data: CreateModalityRequest
): Promise<Modality | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin.modalities().create(data).run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function updateModalityService(
	data: createModalitytype,
	id: string
): Promise<Modality | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin.modalities().update(id, data).run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}

export async function deleteModalityService(
	id: string
): Promise<Modality | undefined> {
	const client = getGurupassClient();
	try {
		const response = await client?.admin.modalities().delete(id).run();
		return response?.data;
	} catch (error: any) {
		toastError(error?.data?.message);
	}
}
